// // // src/service/bookingService.js
// // import { MAIN_API } from "../../config/api";

// // const bookingService = {
// //   // Create Razorpay order
// //   createOrder: async (amount, currency = "INR") => {
// //     try {
// //       const endpoint = `${MAIN_API}/payments/create-order`;
      
// //       console.log('Creating order at:', endpoint);
// //       console.log('Amount:', amount);

// //       const response = await fetch(endpoint, {
// //         method: 'POST',
// //         headers: {
// //           'Content-Type': 'application/json',
// //         },
// //         body: JSON.stringify({
// //           amount: amount,
// //           currency: currency
// //         }),
// //       });

// //       const data = await response.json();
// //       console.log('Order response:', data);
// //       return data;
// //     } catch (error) {
// //       console.error('Error creating order:', error);
// //       throw { success: false, message: error.message || 'Failed to create order. Please try again.' };
// //     }
// //   },

// //   // Create booking after payment
// //   createBooking: async (bookingData) => {
// //     try {
// //       const endpoint = `${MAIN_API}/user/bookings`;
      
// //       console.log('Creating booking at:', endpoint);
// //       console.log('Booking data:', bookingData);

// //       const response = await fetch(endpoint, {
// //         method: 'POST',
// //         headers: {
// //           'Content-Type': 'application/json',
// //         },
// //         body: JSON.stringify(bookingData),
// //       });

// //       const data = await response.json();
// //       console.log('Booking response:', data);
// //       return data;
// //     } catch (error) {
// //       console.error('Error creating booking:', error);
// //       throw { success: false, message: error.message || 'Failed to create booking. Please try again.' };
// //     }
// //   },

// //   // Verify payment (if needed)
// //   verifyPayment: async (paymentData) => {
// //     try {
// //       const endpoint = `${MAIN_API}/payments/verify`;
      
// //       const response = await fetch(endpoint, {
// //         method: 'POST',
// //         headers: {
// //           'Content-Type': 'application/json',
// //         },
// //         body: JSON.stringify(paymentData),
// //       });

// //       const data = await response.json();
// //       console.log('Verify payment response:', data);
// //       return data;
// //     } catch (error) {
// //       console.error('Error verifying payment:', error);
// //       throw { success: false, message: error.message || 'Failed to verify payment. Please try again.' };
// //     }
// //   },
// // };

// // export default bookingService;



// // src/service/bookingService.js
// import { MAIN_API } from "../../config/api";

// const bookingService = {
//   // Create booking directly (without payment flow)
//   createBooking: async (bookingData) => {
//     try {
//       const endpoint = `${MAIN_API}/user/bookings`;
      
//       console.log('Creating booking at:', endpoint);
//       console.log('Booking data:', bookingData);

//       const response = await fetch(endpoint, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(bookingData),
//       });

//       const data = await response.json();
//       console.log('Booking response:', data);
//       return data;
//     } catch (error) {
//       console.error('Error creating booking:', error);
//       throw { success: false, message: error.message || 'Failed to create booking. Please try again.' };
//     }
//   },


//    // Get bookings by user ID
//   getBookingsByUser: async (userId) => {
//     try {
//       const endpoint = `${MAIN_API}/user/bookings/user/${userId}`;
      
//       console.log('Fetching bookings from:', endpoint);

//       const response = await fetch(endpoint, {
//         method: 'GET',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//       });

//       const data = await response.json();
//       console.log('Bookings response:', data);
//       return data;
//     } catch (error) {
//       console.error('Error fetching bookings:', error);
//       throw { success: false, message: error.message || 'Failed to fetch bookings. Please try again.' };
//     }
//   },


  
// };

// export default bookingService;






// src/service/bookingService.js
import { MAIN_API } from "../../config/api";

const bookingService = {
  // Create Razorpay order
  createOrder: async (amount, currency = "INR") => {
    try {
      const endpoint = `${MAIN_API}/payments/create-order`;
      
      console.log('Creating order at:', endpoint);
      console.log('Amount:', amount);

      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          amount: amount,
          currency: currency
        }),
      });

      const data = await response.json();
      console.log('Order response:', data);
      return data;
    } catch (error) {
      console.error('Error creating order:', error);
      throw { success: false, message: error.message || 'Failed to create order. Please try again.' };
    }
  },

  // Create booking after payment
  createBooking: async (bookingData) => {
    try {
      const endpoint = `${MAIN_API}/user/bookings`;
      
      console.log('Creating booking at:', endpoint);
      console.log('Booking data:', bookingData);

      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(bookingData),
      });

      const data = await response.json();
      console.log('Booking response:', data);
      return data;
    } catch (error) {
      console.error('Error creating booking:', error);
      throw { success: false, message: error.message || 'Failed to create booking. Please try again.' };
    }
  },

  // Get bookings by user ID
  getBookingsByUser: async (userId) => {
    try {
      const endpoint = `${MAIN_API}/user/bookings/user/${userId}`;
      
      console.log('Fetching bookings from:', endpoint);

      const response = await fetch(endpoint, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json();
      console.log('Bookings response:', data);
      return data;
    } catch (error) {
      console.error('Error fetching bookings:', error);
      throw { success: false, message: error.message || 'Failed to fetch bookings. Please try again.' };
    }
  },
};

export default bookingService;